import React from 'react';

export const LeftCloud = () => {
    return (
        <svg
            width="250"
            height="215"
            viewBox="0 0 250 215"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Schatten-Ellipse unten */}
            <g filter="url(#filter0_f)">
                <ellipse cx="125" cy="140" rx="79" ry="29" fill="#ACC2EC"/>
            </g>

            {/* Hintergrundform mit Blur */}
            <g filter="url(#filter1_i)">
                <path
                    d="M124.793 0C162.576 0 193.674 28.613 197.605 65.352C197.746 65.35 197.886 65.347 198.026 65.347C220.427 65.347 238.587 83.506 238.587 105.906C238.587 127.957 220.99 145.898 199.073 146.453L198.026 146.467H61.7L61.045 146.463C33.346 146.112 11 123.549 11 95.767C11 69.321 31.249 47.604 57.088 45.273C68.074 18.699 94.249 0.00015 124.793 0Z"
                    fill="url(#paint0_linear)"
                    fillOpacity="0.5"
                />
            </g>

            {/* Zweite Ebene (gleiche Form, anderer Effekt) */}
            <g filter="url(#filter2_i)">
                <path
                    d="M124.793 0C162.576 0 193.674 28.613 197.605 65.352C197.746 65.35 197.886 65.347 198.026 65.347C220.427 65.347 238.587 83.506 238.587 105.906C238.587 127.957 220.99 145.898 199.073 146.453L198.026 146.467H61.7L61.045 146.463C33.346 146.112 11 123.549 11 95.767C11 69.321 31.249 47.604 57.088 45.273C68.074 18.699 94.249 0.00015 124.793 0Z"
                    fill="url(#paint1_linear)"
                    fillOpacity="0.5"
                />
            </g>

            <defs>
                {/* Blur-Ellipse unten */}
                <filter
                    id="filter0_f"
                    x="0.933"
                    y="65.933"
                    width="248.133"
                    height="148.133"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                    <feGaussianBlur
                        stdDeviation="22.5333"
                        result="effect1_foregroundBlur"
                    />
                </filter>

                {/* Innenschatten */}
                <filter
                    id="filter1_i"
                    x="-7.027"
                    y="-18.027"
                    width="263.64"
                    height="182.52"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                    <feOffset dy="4.50667"/>
                    <feGaussianBlur stdDeviation="10.14"/>
                    <feComposite in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1"/>
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                    />
                    <feBlend in2="shape" result="effect1_innerShadow"/>
                </filter>

                {/* Zweiter Innenschatten */}
                <filter
                    id="filter2_i"
                    x="-7.027"
                    y="-18.027"
                    width="263.64"
                    height="182.52"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                    <feOffset dy="4.50667"/>
                    <feGaussianBlur stdDeviation="10.14"/>
                    <feComposite in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1"/>
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
                    />
                    <feBlend in2="shape" result="effect1_innerShadow"/>
                </filter>

                {/* Farbverläufe */}
                <linearGradient
                    id="paint0_linear"
                    x1="124.793"
                    y1="146.467"
                    x2="123.103"
                    y2="0"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#BBCFEE" stopOpacity="0.7"/>
                    <stop offset="1" stopColor="white" stopOpacity="0.9"/>
                </linearGradient>

                <linearGradient
                    id="paint1_linear"
                    x1="124.793"
                    y1="146.467"
                    x2="123.103"
                    y2="0"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#BBCFEE" stopOpacity="0.7"/>
                    <stop offset="1" stopColor="white" stopOpacity="0.9"/>
                </linearGradient>
            </defs>
        </svg>
    )
}